import { render } from "./CInputFile.vue?vue&type=template&id=b45b3958"
import script from "./CInputFile.vue?vue&type=script&lang=js"
export * from "./CInputFile.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__